import { POPOVER_ROLE } from 'consts/enum';
import { addClass, getPreComputedBounds, isEllipsisActive, removeClass } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import ResizeObserver from 'resize-observer-polyfill';
import './popover.scss';

const { EXPANDABLE, ELLIPSIS, TOOLTIP } = POPOVER_ROLE;

export class Popover {
	constructor(props) {
		this.initData(props);
		const { role } = this.data;

		if (role === ELLIPSIS || role === EXPANDABLE) {
			this.initReadMore();
		} else {
			this.initWrapper();
			this.initEventHandlers();
		}
	}

	initData(props) {
		this.engtPopoverInstance = document.getElementById('engtPopover');
		this.engtPopoverOverlay = document.getElementById('engtPopoverOverlay');
		this.data = {
			role: EXPANDABLE,
		};
		this.setter(props);
	}

	initReadMore() {
		const { parent, role } = this.data;

		if (role === ELLIPSIS || role === EXPANDABLE) {
			new ResizeObserver(() => {
				try {
					this.initWrapper();
					this.initEventHandlers();
				} catch (e) {
					console.error('Resizing error in text ellipsiser -> ', e);
				}
			}).observe(parent);
		}
	}

	initWrapper() {
		const { parent, role, textBgColor } = this.data;
		this.isEllipsisActive = isEllipsisActive(parent);

		switch (role) {
			case ELLIPSIS:
			case EXPANDABLE: {
				const readMore = parent && parent.querySelector('.engt-read-more');
				readMore && readMore.parentNode.removeChild(readMore);
				const readMoreSpan = `... <span class="engt-read-more-text">${
					ENGT_CHAT.get('GENERIC_STRINGS')?.READ_MORE || 'Read More'
				}</span>`;

				if (this.isEllipsisActive) {
					const button = document.createElement('button');
					button.innerHTML = readMoreSpan;
					button.className = 'engt-read-more engt-tab-selectable';
					button.setAttribute('tabindex', 0);
					if (textBgColor) {
						button.style.backgroundColor = textBgColor;
					}
					this.html = button;
					parent.style.position = 'relative';
					parent.appendChild(this.html);
				}
				break;
			}
			case TOOLTIP: {
				this.html = parent;
			}
		}
	}

	initEventHandlers() {
		const { role } = this.data;

		if ((this.isEllipsisActive && role === ELLIPSIS) || role === TOOLTIP) {
			this.html.addEventListener('click', this.onReadMoreEllipsisClick.bind(this));
			this.engtPopoverInstance.addEventListener('click', this.onPopoverClick.bind(this));
			this.engtPopoverOverlay.addEventListener('click', this.onClickOutside.bind(this));
			this.html.style.cursor = 'pointer';
		} else if (this.isEllipsisActive && role === EXPANDABLE) {
			this.html.addEventListener('click', this.onReadMoreExpandable.bind(this));
		}
	}

	onReadMoreExpandable(e) {
		e.stopPropagation();
		e.preventDefault();
		this.data.parent.style.maxHeight = '100%';
		this.data?.onClick?.(e, this);
		this.html.innerHTML = '';
	}

	onReadMoreEllipsisClick(e) {
		const { child, role } = this.data;

		const getArrowMark = (xposition, yposition) => {
			const div = document.createElement('div');
			div.className = `arrow-${xposition} arrow-${yposition}`;

			this.engtPopoverInstance.appendChild(div);
		};

		try {
			e.stopPropagation();
			e.preventDefault();
			this.data?.onClick?.(e, this);
			this.engtPopoverInstance.appendChild(child);
			const { target } = e;
			const targetBounds = target.getBoundingClientRect();
			const engtWrapper = document.getElementById('engtWrapper').getBoundingClientRect();
			const popoverClone = getPreComputedBounds(
				this.engtPopoverInstance.cloneNode(true),
				this.engtPopoverOverlay
			);
			const left = targetBounds.left - engtWrapper.left + target.scrollWidth / 2;
			const top = targetBounds.top - engtWrapper.top;
			const popoverHeight = popoverClone.offsetHeight;
			const popoverWidth = popoverClone.offsetWidth;
			const YPlacement = top > popoverHeight ? 'top' : 'bottom';
			let XPlacement = 'middle';
			let X = left - popoverWidth / 2 < 0 ? left : left - popoverWidth / 2;
			if (X + popoverWidth - 10 > engtWrapper.width) {
				XPlacement = 'right';
				X = engtWrapper.width - popoverWidth;
			}
			const Y = YPlacement === 'top' ? top - popoverHeight : top + target.scrollHeight;

			getArrowMark(XPlacement, YPlacement);
			this.engtPopoverInstance.style.transform = `translate3d(${X}px, ${Y}px, 0px)`;
			this.engtPopoverInstance.style.visibility = 'visible';
			this.engtPopoverOverlay.style.display = 'block';
			addClass(this.engtPopoverInstance, `engt-popover-${role.toLowerCase()}`);
			this.engtPopoverInstance.querySelector('a')?.focus?.();
		} catch (e) {
			console.error('Error fetching popover coords', e);
		}
	}

	onPopoverClick(e) {
		e.stopPropagation();
	}

	onClickOutside(e) {
		const { role } = this.data;
		this.engtPopoverInstance.innerHTML = '';
		this.engtPopoverInstance.style = '';
		this.engtPopoverOverlay.style.display = 'none';
		removeClass(this.engtPopoverInstance, `engt-popover-${role.toLowerCase()}`);
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
